/**
 * TitleCell Component for Bay Email Editor
 *
 * Displays property listing with image thumbnail, address, and MLS number.
 * Simplified version for use within the email editor packages.
 *
 * Source: ui/src/components/ListingsDataGrid/TitleCell.jsx
 */

import React from 'react';

interface TitleCellProps {
	rowData?: any;
	data?: any;
}

const TitleCell: React.FC<TitleCellProps> = ({ rowData, data }) => {
	// Use rowData from ka-table or data prop
	const cellData = rowData || data;
	const { image, image_data: imageData, address, city, stateProvince, postalCode: zip, mls } = cellData || {};

	// Get image from either 'image' field or first item in 'image_data' array
	const imageUrl = image || (imageData && imageData[0]) || '';
	const fallbackUrl = encodeURIComponent('https://placehold.co/300x200/e1e1e1/666666?text=No+Image');
	const encodedUrl = imageUrl ? encodeURIComponent(imageUrl) : fallbackUrl;

	return (
		<div className="d-flex w-100 h-100 align-items-center">
			<div className="me-3 position-relative" style={{ width: '48px', height: '36px' }}>
				<img
					src={`https://wsrv.nl/?url=${encodedUrl}&default=${fallbackUrl}`}
					alt="Property image"
					className="rounded-1"
					style={{
						width: '100%',
						height: '100%',
						objectFit: 'cover'
					}}
				/>
			</div>
			<div>
				<div>{address || '-'}</div>
				<div>
					{city}
					{city && stateProvince ? ', ' : ''}
					{stateProvince}
					{stateProvince && zip ? ` ${zip}` : zip}
				</div>
				<div className='text-500'>{mls || '-'}</div>
			</div>
		</div>
	);
};

export default TitleCell;
